import { useEffect } from "react";
const CHANNEL_NAME = 'penny_broadcast_channel';
var pennyBroadcast_BroadcastType = /*#__PURE__*/ function(BroadcastType) {
    BroadcastType["ADD_TEXT_TO_SPEECH_QUEUE"] = "ADD_TEXT_TO_SPEECH_QUEUE";
    BroadcastType["ASSISTANT_MESSAGE_ADDED"] = "ASSISTANT_MESSAGE_ADDED";
    BroadcastType["AUDIO_RETRIEVAL_INITIATED"] = "AUDIO_RETRIEVAL_INITIATED";
    BroadcastType["AUDIO_PLAYBACK_STARTED"] = "AUDIO_PLAYBACK_STARTED";
    BroadcastType["AUDIO_PLAYBACK_STOPPED"] = "AUDIO_PLAYBACK_STOPPED";
    BroadcastType["AUDIO_QUEUE_DRAINED"] = "AUDIO_QUEUE_DRAINED";
    BroadcastType["INTERRUPT_AUDIO_PLAYBACK"] = "INTERRUPT_AUDIO_PLAYBACK";
    BroadcastType["ENABLE_AUDIO_PLAYBACK"] = "ENABLE_AUDIO_PLAYBACK";
    BroadcastType["DISABLE_AUDIO_PLAYBACK"] = "DISABLE_AUDIO_PLAYBACK";
    BroadcastType["LOCK_AUDIO_QUEUE"] = "LOCK_AUDIO_QUEUE";
    BroadcastType["UNLOCK_AUDIO_QUEUE"] = "UNLOCK_AUDIO_QUEUE";
    BroadcastType["MARKER_ADDED"] = "MARKER_ADDED";
    BroadcastType["MESSAGES_RETRIEVED"] = "MESSAGES_RETRIEVED";
    BroadcastType["NEW_MESSAGE_REQUEST_INITIATED"] = "NEW_MESSAGE_REQUEST_INITIATED";
    BroadcastType["NEW_REALTIME_VOICE_INSTANCE"] = "NEW_REALTIME_VOICE_INSTANCE";
    BroadcastType["SUMMARY_ADDED"] = "SUMMARY_ADDED";
    BroadcastType["SYSTEM_MESSAGE_ADDED"] = "SYSTEM_MESSAGE_ADDED";
    BroadcastType["USER_MESSAGE_ADDED"] = "USER_MESSAGE_ADDED";
    BroadcastType["PLAY_ADHOC_AUDIO"] = "PLAY_ADHOC_AUDIO";
    BroadcastType["VOICE_RECORDING_STARTED"] = "VOICE_RECORDING_STARTED";
    BroadcastType["VOICE_RECORDING_STOPPED"] = "VOICE_RECORDING_STOPPED";
    BroadcastType["USER_IS_TALKING"] = "USER_IS_TALKING";
    BroadcastType["USER_SUBMITTED_TEXT"] = "USER_SUBMITTED_TEXT";
    BroadcastType["USER_IS_SILENT"] = "USER_IS_SILENT";
    return BroadcastType;
}({});
const broadcast = (message)=>{
    const broadcastChannel = new BroadcastChannel(CHANNEL_NAME);
    broadcastChannel.postMessage(message);
    broadcastChannel.close();
};
const usePennySubscriber = (listener)=>{
    useEffect(()=>{
        const broadcastChannel = new BroadcastChannel(CHANNEL_NAME);
        broadcastChannel.addEventListener('message', listener);
        return ()=>{
            broadcastChannel.removeEventListener('message', listener);
            broadcastChannel.close();
        };
    }, [
        listener
    ]);
};
const createPennyBroadcastSubscriber = ()=>{
    const pennyBroadcastChannel = new BroadcastChannel(CHANNEL_NAME);
    return pennyBroadcastChannel;
};
const pennyBroadcast = broadcast;
export { pennyBroadcast_BroadcastType as BroadcastType, CHANNEL_NAME, createPennyBroadcastSubscriber, pennyBroadcast as default, usePennySubscriber };
